import React from 'react'
import axios from 'axios'
import { API_ENDPOINT, ASSETS_ENDPOINT } from '../../../../../config'
import store from '../../../../../redux/stores/store'
import './images.styles.scss'

class TourPackageImages extends React.Component {

    constructor(props) {
        super(props)
        this.inputRef = React.createRef()
        this.state = {
            images: props.images || [],
            uploading: false,
            deletingKey: null
        }
    }

    componentDidUpdate(prevProps) {
        if (prevProps.images !== this.props.images || prevProps.tourPackageId !== this.props.tourPackageId) {
            this.setState({
                ...this.state,
                images: this.props.images || []
            })
        }
    }

    resolveImagesFromResponse = (responseData) => {
        const data = responseData && responseData.data ? responseData.data : {}
        const images = data.images
            || (data.tourPackage && data.tourPackage.images)
            || (data.package && data.package.images)
            || (data.tourpackage && data.tourpackage.images)
            || []

        if (Array.isArray(images)) {
            return images
        }
        return this.state.images
    }

    onUpload = (e) => {
        if (e.target.files.length === 0) {
            return
        }
        const tourPackageId = this.props.tourPackageId
        if (!tourPackageId) {
            alert("Create the tour package first, then upload images.")
            return
        }

        const data = new FormData()
        data.append('id', tourPackageId)
        data.append('image', e.target.files[0])
        e.target.value = ""

        this.setState({
            ...this.state,
            uploading: true
        })

        axios({
            method: 'post',
            url: API_ENDPOINT + "/api/tour-package/image/upload",
            headers: {
                "Authorization": store.getState().auth.authorization
            },
            data: data
        }).then(response => {
            if (response.status !== 200) {
                this.setState({ ...this.state, uploading: false })
                return
            }
            if (response.data.status !== 200) {
                this.setState({ ...this.state, uploading: false })
                alert(response.data.message)
                return
            }
            this.setState({
                ...this.state,
                uploading: false,
                images: this.resolveImagesFromResponse(response.data)
            })
        }).catch(error => {
            this.setState({
                ...this.state,
                uploading: false
            })
            alert(error)
        })
    }

    onDelete = (key) => {
        const tourPackageId = this.props.tourPackageId
        if (!tourPackageId) {
            return
        }
        this.setState({
            ...this.state,
            deletingKey: key
        })
        axios({
            method: 'post',
            url: API_ENDPOINT + "/api/tour-package/image/delete",
            headers: {
                "Authorization": store.getState().auth.authorization
            },
            data: {
                id: tourPackageId,
                index: key
            }
        }).then(response => {
            if (response.status !== 200) {
                this.setState({ ...this.state, deletingKey: null })
                return
            }
            if (response.data.status !== 200) {
                this.setState({ ...this.state, deletingKey: null })
                alert(response.data.message)
                return
            }
            const nextImages = this.resolveImagesFromResponse(response.data)
            this.setState({
                ...this.state,
                deletingKey: null,
                images: nextImages.length > 0 || this.state.images.length === 0
                    ? nextImages
                    : this.state.images.filter((item, index) => index !== key)
            })
        }).catch(error => {
            this.setState({
                ...this.state,
                deletingKey: null
            })
            alert(error)
        })
    }

    openFileDialog = () => {
        if (this.inputRef.current) {
            this.inputRef.current.click()
        }
    }

    render() {
        return (
            <div className="row images-row">
                <div className="form-label">
                    <label>Images</label>
                </div>
                <div className="form-input">
                    <div className="tour-package-images">
                        <div className="images-grid">
                            {
                                this.state.images.map((image, key) => {
                                    const imageUrl = String(image).startsWith("http")
                                        ? image
                                        : ASSETS_ENDPOINT + "/" + image
                                    return (
                                        <div key={key} className="image-card">
                                            <img alt="" src={imageUrl} />
                                            <button
                                                type="button"
                                                disabled={this.state.deletingKey === key}
                                                onClick={() => this.onDelete(key)}
                                            >
                                                {this.state.deletingKey === key ? "Deleting..." : "Delete"}
                                            </button>
                                        </div>
                                    )
                                })
                            }
                            {
                                this.state.images.length === 0 && <p className="no-images">No images yet.</p>
                            }
                        </div>
                        <div className="image-actions">
                            <button
                                type="button"
                                disabled={this.state.uploading || !this.props.tourPackageId}
                                onClick={this.openFileDialog}
                            >
                                {this.state.uploading ? "Uploading..." : "Upload New Image"}
                            </button>
                            <input
                                ref={this.inputRef}
                                type="file"
                                accept=".jpg,.jpeg,.png,.webp"
                                onChange={this.onUpload}
                                disabled={this.state.uploading || !this.props.tourPackageId}
                                style={{ display: "none" }}
                            />
                            {
                                !this.props.tourPackageId && <span className="hint">Save the tour package before uploading images.</span>
                            }
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}

export default TourPackageImages
